(() => {
  const htmlEl = document.documentElement;

  function handleThemeToggle() {
    const isDark = htmlEl.classList.contains('dark');
    if (isDark) {
      htmlEl.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    } else {
      htmlEl.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    }
  }

  // Delegated click listener works for current and dynamically rendered toggle buttons
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const toggleBtn = target.closest('[data-night-mode-toggle]');
    if (!toggleBtn) return;
    event.preventDefault();
    handleThemeToggle();
  });
})();
